<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12 pt-0>
						<label for="title" class="body-1">
							Tipo de Rol
						</label>
						<v-select
						:items="listRoles"
						background-color="white"
						class="body-1 mt-2"
						hide-details
						chips
						box
						label="Tipo de Rol"
						item-text="name"
						item-value="id"
						v-model="model.typeRoleId"
						></v-select>
					</v-flex>
					<v-flex xs12>
						<label for="title" class="body-1">Nombre</label>
						<v-text-field
							background-color="white"
							box
							class="body-1 mt-1"
							hide-details
							label="Nombre"
							required
							v-model="$v.model.name.$model"
							:error="$v.model.name.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-0>
						<v-subheader class="pa-0 subheading">
							Configuración de Filtros
						</v-subheader>
					</v-flex>
					<v-flex xs12 pt-0>
						<label for="title" class="body-1">
							Listado de Ventas
						</label>
						<v-select
							v-model="model.configFilters.sales.subsidiaries.values"
							:items="subsidiaries"
							background-color="white"
							box
							class="body-1 mt-2"
							chips
							hide-details
							item-text="sucursalName"
							item-value="id"
							label="Sucursales"
							multiple
						></v-select>
					</v-flex>
					<v-flex xs12>
						<label for="title" class="body-1">
							Listado de Almacenes
						</label>
						<v-select
							v-model="model.configFilters.warehouses.subsidiaries.values"
							:items="subsidiaries"
							background-color="white"
							box
							class="body-1 mt-2"
							chips
							hide-details
							item-text="sucursalName"
							item-value="id"
							label="Sucursales"
							multiple
						></v-select>
						<v-select
							v-model="model.configFilters.warehouses.warehouses.values"
							:items="warehouses"
							background-color="white"
							box
							class="body-1 mt-2"
							chips
							hide-details
							item-text="name"
							item-value="id"
							label="Almacenes"
							multiple
						></v-select>
					</v-flex>
					<v-flex xs12>
						<label for="title" class="body-1">
							Listado de Productos
						</label>
						<v-select
							v-model="model.configFilters.products.warehouses.values"
							:items="warehouses"
							background-color="white"
							box
							class="body-1 mt-2"
							chips
							hide-details
							item-text="name"
							item-value="id"
							label="Almacenes"
							multiple
						></v-select>
					</v-flex>
					<v-flex xs12>
						<label for="title" class="body-1">
							Listado de Sucursales
						</label>
						<v-select
							v-model="model.configFilters.subsidiaries.subsidiaries.values"
							:items="subsidiaries"
							background-color="white"
							box
							class="body-1 mt-2"
							chips
							hide-details
							item-text="sucursalName"
							item-value="id"
							label="Sucursales"
							multiple
						></v-select>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const PAGE_ROLE_LIST = 'page-role';

async function created() {
	this.loadResources();
	if (this.mode === 'edit') {
		const { data: record } = await this.$http.get(`role/${this.roleId}`);
		if (record.data) {
			if (record.data.configFilters) {
				record.data.configFilters.subsidiaries = record.data.configFilters.subsidiaries ?
					record.data.configFilters.subsidiaries :
					{ subsidiaries: { fieldName: 'id', values: [] } };
			}
			this.model = {
				typeRoleId: record.data.typeRoleId,
				name: record.data.name,
				configFilters: record.data.configFilters ? record.data.configFilters
					: this.configFilters,
			};
		}
	}
	this.model.codeCompany = this.codeCompany;
	this.model.codeProject = this.codeProject;
	this.listRol();
}

async function listRol() {
	const params = {
		codeProject: this.$route.params.codeProject,
	};
	try {
		const response = await this.$http.get('types-roles', { params });
		this.listRoles = response.data.data;
	} catch (error) {
		this.showError();
	}
}

function closeModal() {
	this.goTo(PAGE_ROLE_LIST);
}

async function loadResources() {
	try {
		const { data: resources } = await this.$httpSales.get(`companies/${this.codeCompany}/info`);
		this.subsidiaries = resources.subsidiaries;
		this.warehouses = resources.warehouses;
	} catch (err) {
		if (err.response.status === 400) {
			if (err.response.data.message === 'COMPANY_NOT_FOUND') {
				this.showNotification('No se encontraron datos de la compañía. Pero puedes seguir creando el rol sin problemas.',
					'primary');
			}
		}
	}
}

function mode() {
	return this.roleId ? 'edit' : 'create';
}

async function submitForm() {
	const method = this.mode === 'create' ? 'post' : 'put';
	const url = this.mode === 'create' ? 'role' : `role/${this.roleId}`;
	const headers = {
		Accept: process.env.ACCEPT_SERVICE_V2,
	};
	this.loading = true;
	try {
		await this.$http[method](url, this.model, { headers });
		this.goTo(PAGE_ROLE_LIST);
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		model: {
			codeCompany: {
				required,
			},
			name: {
				required,
			},
			codeProject: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		countries: [],
		configFilters: {
			sales: {
				subsidiaries: {
					fieldName: 'com_subsidiary_id',
					values: [],
				},
			},
			warehouses: {
				subsidiaries: {
					fieldName: 'subsidiary_id',
					values: [],
				},
				warehouses: {
					fieldName: 'id',
					values: [],
				},
			},
			products: {
				warehouses: {
					fieldName: 'warehouse_id',
					values: [],
				},
			},
			subsidiaries: {
				subsidiaries: {
					fieldName: 'id',
					values: [1, 2],
				},
			},
		},
		listRoles: [],
		loading: false,
		model: {
			codeProject: this.codeProject,
			name: '',
			codeCompany: this.codeCompany,
			isAdmin: true,
			typeRoleId: null,
			configFilters: {
				sales: {
					subsidiaries: {
						fieldName: 'com_subsidiary_id',
						values: [],
					},
				},
				warehouses: {
					subsidiaries: {
						fieldName: 'subsidiary_id',
						values: [],
					},
					warehouses: {
						fieldName: 'id',
						values: [],
					},
				},
				products: {
					warehouses: {
						fieldName: 'warehouse_id',
						values: [],
					},
				},
				subsidiaries: {
					subsidiaries: {
						fieldName: 'id',
						values: [1, 2],
					},
				},
			},
		},
		subsidiaries: [],
		warehouses: [],
	};
}

export default {
	name: 'roles-form',
	created,
	computed: {
		mode,
	},
	data,
	methods: {
		closeModal,
		listRol,
		loadResources,
		submitForm,
	},
	props: {
		codeCompany: {
			type: String,
			required: true,
		},
		codeProject: {
			type: String,
			required: true,
		},
		roleId: {
			type: [Number, String],
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-form.vue